import { render } from "./taxInnvoiceAr.vue?vue&type=template&id=e566ad3e&scoped=true"
import script from "./taxInnvoiceAr.vue?vue&type=script&lang=js"
export * from "./taxInnvoiceAr.vue?vue&type=script&lang=js"

import "./taxInnvoiceAr.vue?vue&type=style&index=0&id=e566ad3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e566ad3e"]])

export default __exports__